<template>
  <div>
     <section>
       <VUEAppHeader :VisualizzaMenu="VisualizzaMenu" :SitoSelezionato="SitoSelezionato" :ListaSiti="ListaSiti" :CatenaSelezionata="CatenaSelezionata" :ListaCatene="ListaCatene" @onClickCambiaMenu="ClickCambiaMenu()" @onSelezionaSito="$emit('onSelezionaSito', $event)" @onSelezionaCatena="$emit('onSelezionaCatena', $event)"></VUEAppHeader>
       <section>
         <section>
           <VUEAppSideMenu v-if="MenuAttuale.length > 0" @onClickChiudiMenuDaSideMenu="ClickChiudiMenu" @onClickNascondiAllMenuDaSideMenu="ClickNascondiAllMenu" :VisualizzaMenu="VisualizzaMenu" :MenuAttuale="MenuAttuale" :Altezza="Altezza"></VUEAppSideMenu>  
           <section id="content">
             <section class="vbox"  style="display:block;">          
              <section class="padder" style="overflow-y: auto;" :style="{height: (Altezza - 50) + 'px'}">
                <div v-if="Titolo != ''" class="breadcrumb no-border no-radius b-b b-light" style="width: calc(100% - 65px); margin-left: 65px;">
                  <span class="ZMTitoloContenuti">{{Titolo}}</span>
                </div>
                <slot name="Content"></slot>
             </section>
             </section>
             <a href="#" class="hide nav-off-screen-block" data-toggle="class:nav-off-screen, open" data-target="#nav,html"></a>
           </section>
           <aside class="bg-light lter b-l aside-md hide" id="notes">
             <div class="wrapper">Notification</div>
           </aside>
         </section>
       </section>
     </section>
  </div>
</template>

<script>
import { SystemInformation } from '@/SystemInformation';
import VUEAppSideMenu from '@/components/FrameComponentsMultiPurpose/VUEAppSideMenu.vue';
import VUEAppHeader from '@/components/FrameComponentsMultiPurpose/VUEAppHeader.vue';

export default 
{
    name: "VUEGestionale",
    props: ['Titolo', 'MenuAttuale', 'SitoSelezionato', 'ListaSiti', 'CatenaSelezionata', 'ListaCatene'],
    emits: ['onSelezionaSito', 'onSelezionaCatena'],
    data() 
    {
     return { 
              UserInformation        : SystemInformation.UserInformation,
              Altezza                : document.documentElement.clientHeight,              
              VisualizzaMenu         : false,              
            };
    },
    components: 
    {
      VUEAppSideMenu,
      VUEAppHeader,
    },
    methods: 
    {
      ClickCambiaMenu()
      {
        this.VisualizzaMenu = !this.VisualizzaMenu
      },

      ClickChiudiMenu()
      {
        this.VisualizzaMenu = false
      },

      ClickNascondiAllMenu()
      {
        this.VisualizzaMenu = false
      },

      getDimensions()
      {
        this.Altezza = document.documentElement.clientHeight;
      },
    },
    mounted() 
    {
      window.addEventListener('resize', this.getDimensions);
      window.addEventListener('hashchange', this.ClickChiudiMenu)
    },
    unmounted() 
    {
      window.removeEventListener('resize', this.getDimensions);
      window.removeEventListener('hashchange', this.ClickChiudiMenu)
    },
};
</script>

<style scoped>
  .dropdown-menu {
    display: block;
  }
</style>